import Vue from 'vue'
import VueAutonumeric from '~/components/tools/VueAutonumeric.vue'

Vue.component("VueAutonumeric", VueAutonumeric)